/*

 MIT License

 Copyright (c) 2022 Looker Data Sciences, Inc.

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in all
 copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 SOFTWARE.

 */


/**
 * NOTE: This is an auto-generated file changes within may be overwritten
 * Run `yarn workspace @looker/icons build` to update
 */

import React from 'react'
import type { StyledIcon, StyledIconProps } from '@styled-icons/styled-icon'
import { StyledIconBase } from '@styled-icons/styled-icon'

export const VisScatter: StyledIcon = React.forwardRef<
  SVGSVGElement,
  StyledIconProps
>((props, ref) => {
  const attrs: React.SVGProps<SVGSVGElement> = {
      "fill": "currentColor",
  "xmlns": "http://www.w3.org/2000/svg",
  }

  return (
    <StyledIconBase
      iconAttrs={attrs}
      iconVerticalAlign="middle"
      iconViewBox="0 0 24 24"
      {...props}
      ref={ref}
    >
      <path d="M13.5328 8.93563C13.5328 9.78163 12.8468 10.4676 12.0008 10.4676C11.1548 10.4676 10.4688 9.78163 10.4688 8.93563C10.4688 8.08963 11.1548 7.40363 12.0008 7.40363C12.8468 7.40363 13.5328 8.08963 13.5328 8.93563Z" />

      <path d="M18.1271 14.8087C18.1271 16.36 16.8698 17.6173 15.3184 17.6173C13.7671 17.6173 12.5098 16.36 12.5098 14.8087C12.5098 13.2573 13.7671 12 15.3184 12C16.8698 12 18.1271 13.2573 18.1271 14.8087Z" />

      <path d="M8.93618 15.8301C8.93618 16.2528 8.59351 16.5961 8.17018 16.5961C7.74751 16.5961 7.40417 16.2534 7.40417 15.8301C7.40417 15.4074 7.74684 15.0641 8.17018 15.0641C8.59284 15.0641 8.93618 15.4068 8.93618 15.8301Z" />

      <path d="M8.25547 10.8088C8.25547 11.4668 7.72214 12.0001 7.06414 12.0001C6.40614 12.0001 5.8728 11.4668 5.8728 10.8088C5.8728 10.1508 6.40614 9.61743 7.06414 9.61743C7.72214 9.61743 8.25547 10.1508 8.25547 10.8088Z" />

      <path d="M19.9159 19.9147H4.08594V4.08466H19.9159V19.9147ZM4.59727 19.404H19.4059V4.59532H4.59727V19.404Z" />

    </StyledIconBase>
  )
})

VisScatter.displayName = 'VisScatter'

export const VisScatterDimensions = {height: 24, width: 24}
